import React from 'react';
import styled from 'styled-components';

const RoleWrapper = styled.div`
	display: flex;
	margin: 7px 0 7px 0;
`;

const RoleName = styled.div`
	padding: 4px;
	font-size: 13px;
	font-weight: 600;
	&.no-icon {
		padding-left: 12px;
	}
`;

const RoleTaskAmount = styled.div`
	padding: 4px;
	font-size: 13px;
	font-weight: 300;
`;

const Role = ({role, hideIcon, taskAmount}) => {
	return (
		<RoleWrapper>
			<RoleName className={'no-icon'}>{role.name}</RoleName>
			{taskAmount !== null && taskAmount !== undefined ? <RoleTaskAmount>{'(' + taskAmount + ')'}</RoleTaskAmount> : null}
		</RoleWrapper>
	);
};

export default Role;
